import { Component, Input, OnChanges } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';

@Component({
  selector: 'hcf-person-by-service-category',
  templateUrl: './person-by-service-category.component.html',
  styleUrls: ['./person-detail.component.scss'],
  standalone: false,
})
export class PersonByServiceCategroyComponent implements OnChanges {
  @Input() serviceCategory: WebApiModel.ServiceCategory;
  @Input() placeDetail: WebApiModel.Place;
  @Input() componentIndex: number;
  @Input() numberOfServiceCategories: number;

  peopleBySerivceCategory: WebApiModel.Person[] = [];
  detailsHidden: boolean = false;
  numberOfDoctors: number = 0;

  ngOnChanges() {
    // expand the first category by default if there is only one
    // this.detailsHidden = (this.numberOfServiceCategories > 1 || this.componentIndex > 0);

    // or always expand the first category
    // this.detailsHidden = this.componentIndex > 0;

    // Group people by service category.
    const filteredPeopleByServiceCategory: WebApiModel.Person[] = [];
    this.placeDetail.people.forEach((person) => {
      person.serviceCategories.forEach((category) => {
        if (category.name === this.serviceCategory.name) {
          filteredPeopleByServiceCategory.push(person);
        }
      });
    });

    this.peopleBySerivceCategory = filteredPeopleByServiceCategory;
  }

  setDetailsVisible(): void {
    this.detailsHidden = !this.detailsHidden;
  }
}
